export const formatAffirmation = (value: boolean | null | undefined) => {
  if (value === false) return 'No';
  if (value === true) return 'Yes';
  return 'error';
};
